import { render, staticRenderFns } from "./waterPurifierDetail.vue?vue&type=template&id=e45714b0&scoped=true"
import script from "./waterPurifierDetail.vue?vue&type=script&lang=js"
export * from "./waterPurifierDetail.vue?vue&type=script&lang=js"
import style0 from "./waterPurifierDetail.vue?vue&type=style&index=0&id=e45714b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45714b0",
  null
  
)

export default component.exports